import React from 'react';
import exclamation from '../assets/images/icons/square-exclamation-warning.svg';

const WarningInformation = ({ information }) => {
  if (information) {
    return (
      <div className='warning-message'>
        <img src={exclamation} alt='Exclamation' loading='eager'/>
        <p className='message'>{information}</p>
      </div>
    );
  } else {
    return null;
  }
};

export default WarningInformation;